import { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux'

import { Button, 
    Checkbox, 
    Dialog, 
    DialogActions, 
    DialogContent, 
    DialogTitle, 
    Grid, 
    List, 
    ListItem, 
    ListItemButton, 
    ListItemIcon, 
    ListItemText, 
    Typography, 
    useTheme 
} from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

import { AppDispatch, RootState } from '../store';
import { Company } from "../interfaces/auth.interface";
import { setCompanySelected } from "../store/slices/auth";

interface SelectCompanyModalInterface {
    open: boolean;
    cancelAction?: () => void,
    errorMessage: (arg0: string) => {}
}

const SelectCompanyModal = (props: SelectCompanyModalInterface) => {

    const theme = useTheme();
    const dispatch = useDispatch<AppDispatch>();
    const [company, setCompany] = useState<Company | null>(null)
    const authState = useSelector((state: RootState) => state.auth);

    useEffect(() => {
        if (!authState?.companyselected || company) {
            return;
        }
        setCompany(authState.companyselected)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authState?.companyselected])

    const hadlerSelectCompany = (companyData: Company) => {
        if (companyData === company) {
            setCompany(null);
        } else {
            setCompany(companyData);
        }
    }

    const hadlerSetCompany = () => {
        if (company === null) {
            props.errorMessage("Debes seleccionar una compañía");
            return;
        }
        if (company.Id !== authState.companyselected?.Id ) {
            dispatch(setCompanySelected(company));
            // window.location.reload();
        }
        // if (props?.cancelAction) {
        //     props?.cancelAction()
        // }
    }

    return (
        <Dialog
            // fullScreen={fullScreen}
            // style={{width: "35rem"}}
            open={props.open}
            // onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
        >
            <DialogTitle id="responsive-dialog-title" style={{padding: "0", margin: "1.5rem 2rem 0 2rem"}} variant="h5">
                Seleccione una corporación
            </DialogTitle>
            <DialogContent style={{width: "100%", height: "50%", padding: "0"}}>
            {/* <DialogContentText> */}
                <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                {authState.sessionData?.Companies.map((c, i) => {
                    return (
                    <ListItem
                        key={i}
                        style={{padding: "0 1.5rem"}}
                    >
                    <ListItemButton 
                        role={undefined} 
                        onClick={() => hadlerSelectCompany(c)} 
                        style={{borderBottom: "1px solid #E8E8E8"}}
                    >
                        <ListItemIcon style={{minWidth: "1.38rem"}}>
                            <Checkbox
                                edge="start"
                                checked={c.Id === company?.Id}
                                tabIndex={-1}
                                inputProps={{ 'aria-labelledby': c.Code }}
                            />
                        </ListItemIcon>
                        <ListItemText 
                            disableTypography
                            primary={
                                <Typography 
                                    variant="body2" 
                                    style={{
                                        color: theme.s10palette.S10Greygrey700,
                                        fontFamily: "Roboto",
                                        fontSize: "0.875rem",
                                        fontStyle: "normal",
                                        fontWeight: 600,
                                        lineHeight: "1.25rem",
                                    }} 
                                >
                                    {c.Name}
                                </Typography>
                            }
                            id={c.Code} 
                        />
                    </ListItemButton>
                    </ListItem>
                    )
                })}
                </List>
            {/* </DialogContentText> */}
            </DialogContent>
            <DialogActions>
                <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"}>
                    <Grid item xs={6}>
                        {props.cancelAction && <Button 
                            variant="outlined" 
                            style={{width: "8rem"}}
                            startIcon={<CloseIcon style={{height: "1rem"}} />}
                            onClick={props.cancelAction}
                        >
                            Cancelar
                        </Button>}
                    </Grid>
                    <Grid item xs={6} textAlign={"right"}>
                        <Button 
                            variant="contained" 
                            style={{width: "8rem"}}
                            startIcon={<CheckIcon style={{height: "1rem"}} />}
                            onClick={hadlerSetCompany}
                            disabled={
                                !company ||
                                (!!authState.companyselected 
                                && !!company 
                                && company.Id === authState.companyselected?.Id)
                            }
                        >
                            Aceptar
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default SelectCompanyModal;